import isEqual from 'lodash/isEqual';
import { trimParams, isHashChange } from '@/lib/params';

export default {
  data: () => ({
    resourceParams: {},
    REMOVABLE_PARAMS: ['preview', 'parent_url', 'install_method']
  }),
  computed: {
    defaultResourceParams: () => {},
    popupParams() {
      return Object.keys(this.resourceParams)
        .filter(k => {
          return this.isPopupParam(k);
        })
        .reduce((a, k) => ({ ...a, [k]: this.resourceParams[k] }), {});
    }
  },
  watch: {
    $route(to, from) {
      if (isHashChange(to, from)) return;

      this.resourceParams = this.filterQuery(to.query);
      this.fetchResource(this.resourceParams);
    }
  },
  methods: {
    filterQuery(query) {
      return Object.keys(query)
        .filter(k => !this.REMOVABLE_PARAMS.includes(k))
        .reduce((a, k) => ({ ...a, [k]: query[k] }), {});
    },
    refreshResourceWithParams(params) {
      const oldParams = this.resourceParams;
      const newParams = trimParams({ ...oldParams, ...params });
      if (isEqual(oldParams, newParams)) this.fetchResource(newParams);
      else this.$store.state.window.windowService.pushState(newParams);
    },
    searchResource(params) {
      this.refreshResourceWithParams({
        ...this.resourceParams,
        ...params
      });

      if (this.$store.getters['widget/enablePaginationScroll'])
        this.$store.state.window.windowService.scrollTo(
          -this.$store.state.widget.widget.fixed_top_menu_height
        );
    },
    isPopupParam: _param => true
  }
};
